import React, { useContext, useState, useRef, useEffect } from "react";
import { components } from "react-select";
import { PromoContext } from "@context/PromoContext";
import RedemptionsOptions from "@components/RedemptionDetails/RedemptionsOptions";
import RedemptionsPlaceholder from "@components/RedemptionDetails/RedemptionsPlaceholder";
import RedemptionsSelectedValue from "@components/RedemptionDetails/RedemptionsSelectedValue";
import SearchSelect from "@components/SearchSelect";

const RedemptionsSelect = ({ ticketClass = 0, searchOptions }) => {
    const { selectedPromo, handleSelectPromo } = useContext(PromoContext);
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const selectRef = useRef(null);

    // Adds event listeners so that any clicks outside of the promo dropdown closes the dropdown
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (selectRef.current && !selectRef.current.contains(event.target)) {
                setIsMenuOpen(false);
            }
        };
        const handleEscape = (event) => {
            if (event.key === "Escape") {
                setIsMenuOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        document.addEventListener("keydown", handleEscape);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
            document.removeEventListener("keydown", handleEscape);
        };
    }, []);

    const handleMenuDropdown = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const handleOnChangePromo = (option, { action }) => {
        if (action === "clear") {
            handleSelectPromo(null);
            setIsMenuOpen(false);
        } else if (action === "select-option") {
            handleSelectPromo(option);
            setIsMenuOpen(false);
        }
    };
    
    const CustomDropdown = (props) => {
        const { selectProps, innerProps } = props;
        const { handleMenuDropdown } = selectProps;

        return (
            <components.DropdownIndicator 
                {...props}
                innerProps={{
                    ...innerProps,
                    onMouseDown: (e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        handleMenuDropdown();
                    },
                }}
            >
            </components.DropdownIndicator>
        );
    };

    return (
        <>
            <div 
                className="redemptions__wrapper-search"
                ref={selectRef}
            >
                <SearchSelect
                    className="redemptions"
                    placeholder="Select an available promo"
                    aria-label="Select an active promo"
                    options={searchOptions}
                    onChange={handleOnChangePromo}
                    isClearable={true}
                    handleMenuDropdown={handleMenuDropdown}
                    components={{
                        DropdownIndicator: CustomDropdown,
                        IndicatorSeparator: () => null,
                        Input: () => null,
                        Option: (props) => <RedemptionsOptions props={props} ticketClass={ticketClass}/>,
                        Placeholder: (props) => <RedemptionsPlaceholder props={props}/>,
                        SingleValue: (props) => <RedemptionsSelectedValue props={props} ticketClass={ticketClass} />,
                    }}
                    openMenuOnClick={true}
                    value={selectedPromo}
                    menuIsOpen={isMenuOpen}
                />
            </div>
        </>
    );
};

export default RedemptionsSelect;
